import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setIsCreating,
  resetBreadcrumbs,
} from "../../store/slices/navigationSlice";
import ProjectWizard from "./ProjectWizard";

export default function RouteWrapper({ creating }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsCreating(creating));
    // Reset breadcrumbs (empty) when entering Home/Create flows
    dispatch(resetBreadcrumbs());
  }, [creating, dispatch]);
  return <ProjectWizard />;
}
